// import * as WebBrowser from 'expo-web-browser'
import { Platform } from 'react-native'
import { appLocationAndroid, appURLAndroid, appLocationIOS, appURLIOS, appName, appAppleID, appAndroidID } from '../../env.json'
import AppLink from 'react-native-app-link'

export const isMobileDevice = () => {
  let inAMobileDevice = false

  if (Platform.OS === 'ios' || Platform.OS === 'android') {
    inAMobileDevice = true
  } else {
    const platformDetect = require('react-device-detect')
    inAMobileDevice = platformDetect.isMobile
  }
  return inAMobileDevice
}

export const isMobile = () => { return Platform.OS === 'ios' || Platform.OS === 'android' }

export const areMobileDimensions = (width) => {
  return width < 768
}

export const areTabletPortraitDimensions = (width) => {
  return width >= 768 && width < 1024
}

export const areTabletLandscapeDimensions = (width) => {
  return width >= 1024 && width < 1280
}

export const areLaptopDimensions = (width) => {
  return width >= 1280 && width < 1920
}

export const areDesktopDimensions = (width) => {
  return width >= 1920
}

export const tabletPortraitUpDimensions = (width) => {
  return width >= 768
}

export const tabletLandscapeUpDimensions = (width) => {
  return width >= 1024
}

export const laptopUpDimensions = (width) => {
  return width >= 1280
}

export const isAndroid = () => {
  const platformDetect = require('react-device-detect')
  return platformDetect.isAndroid
}

export const isIOS = () => {
  const platformDetect = require('react-device-detect')
  return platformDetect.isIOS
}

export const isMobileSafari = () => {
  const platformDetect = require('react-device-detect')
  return platformDetect.isMobileSafari
}

export const openAppIfIsInstalled = async (callback) => {
  if (isMobileDevice() && Platform.OS === 'web') {
    const platformDetect = require('react-device-detect')
    const isAndroid = platformDetect.isAndroid
    const appLocation = isAndroid ? appLocationAndroid : appLocationIOS
    const appURL = isAndroid ? appURLAndroid : appURLIOS
    const canBeOpened = await AppLink.maybeOpenURL(appLocation, { appName: appName, appStoreLocale: 'us', appStoreId: appAppleID, playStoreId: appAndroidID })
    if (!canBeOpened) {
      setTimeout(() => { window.location = appURL }, 500)
    }
  }
}
